import { render, staticRenderFns } from "./BackToTopButton.vue?vue&type=template&id=f01d08bc&scoped=true"
import script from "./BackToTopButton.vue?vue&type=script&lang=js"
export * from "./BackToTopButton.vue?vue&type=script&lang=js"
import style0 from "./BackToTopButton.vue?vue&type=style&index=0&id=f01d08bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f01d08bc",
  null
  
)

export default component.exports